import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleCardsSection from './components/ArticleCardsSection';
import ComparisonTable from './components/ComparisonTable';
import SeoContent from './components/SeoContent';
import CtaBanner from './components/CtaBanner';
import TestimonialSection from './components/TestimonialSection';

export default function Home() {
  useEffect(() => {
    document.title = 'Kakobuy Spreadsheet Polska 2026 – Najlepsze Finds, Linki Produktów i Poradnik | KakobuyFinds';
  }, []);

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kakobuyfinds.mom';

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <TrustSection />
        <CategoryGrid />
        <ArticleCardsSection />
        <ComparisonTable />
        <SeoContent />
        <CtaBanner />
        <TestimonialSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'KakobuyFinds',
            url: siteUrl,
            description: 'Kakobuy Spreadsheet Polska – znajdź najlepsze produkty, linki, kategorie i aktualne Kakobuy Finds. Kompletny przewodnik zakupowy 2026.',
            inLanguage: 'pl',
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: 'Czym jest Kakobuy Spreadsheet?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Kakobuy Spreadsheet to zaawansowane narzędzie w formie arkusza kalkulacyjnego, które zawiera gotowe, uporządkowane listy produktów z bezpośrednimi linkami, kategoriami i porównaniami cen.',
                },
              },
              {
                '@type': 'Question',
                name: 'Jak korzystać z Kakobuy Spreadsheet?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Wystarczy przejść na stronę główną arkusza, wybrać interesującą kategorię i przeglądać gotowe listy produktów.',
                },
              },
              {
                '@type': 'Question',
                name: 'Czy Kakobuy Spreadsheet jest bezpieczny?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Tak, wszystkie linki produktowe w arkuszu pochodzą ze sprawdzonych źródeł i są regularnie weryfikowane.',
                },
              },
              {
                '@type': 'Question',
                name: 'Ile kategorii produktów zawiera Kakobuy Spreadsheet?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Kakobuy Spreadsheet zawiera 14 kategorii produktowych, w tym buty, bluzy, T-Shirty, kurtki, spodnie, nakrycia głowy, zestawy, bieliznę, koszulki sportowe, akcesoria, torby, paski, perfumy i inne.',
                },
              },
              {
                '@type': 'Question',
                name: 'Czy Kakobuy Spreadsheet działa w Polsce?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Tak, Kakobuy Spreadsheet jest w pełni dostępny dla polskich użytkowników. Zawiera informacje o dostępności wysyłki do Polski i orientacyjnych kosztach przesyłki.',
                },
              },
            ],
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: 'Strona główna', item: `${siteUrl}/` },
            ],
          }),
        }}
      />
    </>
  );
}